import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {GalleryComponent} from './gallery.component';
import {AuthGuard} from '../login/auth.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'gallery/:pId/:qId', component: GalleryComponent,canActivate: [AuthGuard]}

    ])
  ],
  exports: [
    RouterModule
  ]
})
export class GalleryRoutingModule { }
